export default __webpack_public_path__ + "static/media/telegram.29fa1a7a.svg";